<template>
  <div class="dashboard-card" @click="$emit('click')">
    <div class="card-preview">
      <div
        v-if="previewSlots.length"
        class="preview-grid"
        :class="'preview-grid--' + previewSlots.length"
      >
        <div
          v-for="(slot, index) in previewSlots"
          :key="'plot-' + index"
          class="preview-item"
        >
          <MiniPlotPreview :plot-config="slot" />
        </div>
      </div>
    </div>
    
    <div class="card-content">
      <div class="card-info">
        <h3 class="card-title">{{ dashboard.title }}</h3>
        <div class="card-stats">
          <div class="stat-item">
            <v-icon size="17" class="stat-icon">mdi-view-grid</v-icon>
            <span class="stat-text">{{ dashboard.plotCount }}/{{ dashboard.maxPlots }}</span>
          </div>
          <div class="stat-item" v-if="dashboard.shared">
            <v-icon size="17" class="stat-icon">mdi-earth</v-icon>
            <span class="stat-text">Shared</span>
          </div>
        </div>
      </div>
      <button class="card-menu-btn" @click.stop="$emit('menu')">
        <v-icon size="26">mdi-dots-vertical</v-icon>
      </button>
    </div>

    <button 
      v-if="dashboard.isStarred" 
      class="star-btn" 
      @click.stop="$emit('star')"
    >
      <img :src="starIcon" alt="Star" class="star-icon" />
    </button>
  </div>
</template>

<script>
import MiniPlotPreview from "@/components/dashboard/MiniPlotPreview.vue";

export default {
  name: "DashboardCard",
  components: { MiniPlotPreview },
  props: {
    dashboard: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      starIcon: require("@/assets/Images/Dashboard/star.svg"),
    };
  },
  computed: {
    /** Up to 4 `{ data, chartData }` entries — only real plots (no placeholder cells). */
    previewSlots() {
      const plots = this.dashboard.previewPlotConfigs || [];
      return plots.filter(Boolean).slice(0, 4);
    },
  },
};
</script>

<style scoped>
@import '../../assets/Styling/agenticDashboard/dashboardCard.css';
</style>

